import { apiMiddleware } from 'redux-api-middleware'
import { routerMiddleware } from 'connected-react-router'
import callAPI from 'utils/callAPI'
import keyMirror from 'pkeymirror'

// ------------------------------------
// Constants
// ------------------------------------
export const UTILITY_MAIN = keyMirror({
  INIT_REQUEST: null,
  INIT_SUCCESS: null,
  DELETE_ACCOUNT_REQUEST: null,
  DELETE_ACCOUNT_SUCCESS: null
}, 'UTILITY_MAIN')

// ------------------------------------
// Actions
// ------------------------------------
export function init() {
  return (dispatch) => {
    dispatch(callAPI({
      dispatch: dispatch,
      endpoint: '/cgs/api/lifecenter/initLifeStylePage',
      method: 'POST',
      requestAction: UTILITY_MAIN.INIT_REQUEST,
      successAction: UTILITY_MAIN.INIT_SUCCESS,
      success: function(result) {}
    }))
  }
}

export function deleteAccount(data) {
  console.log(data)
  return dispatch => {
    dispatch(
      callAPI({
        dispatch: dispatch,
        endpoint: '/cgs/api/lifecenter/deleteAccount',
        method: 'POST',
        body: data,
        requestAction: UTILITY_MAIN.DELETE_ACCOUNT_REQUEST,
        successAction: UTILITY_MAIN.DELETE_ACCOUNT_SUCCESS,
        success: function(result) {
          dispatch(init())
        }
      })
    )
  }
}

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [UTILITY_MAIN.INIT_REQUEST]: (state, action) =>
    Object.assign({}, state, action.payload),
  [UTILITY_MAIN.INIT_SUCCESS]: (state, action) =>
    Object.assign({}, state, action.payload),
  [UTILITY_MAIN.DELETE_ACCOUNT_REQUEST]: (state, action) =>
    Object.assign({}, state, action.payload),
  [UTILITY_MAIN.DELETE_ACCOUNT_SUCCESS]: (state, action) =>
    Object.assign({}, state, action.payload)
}

// ------------------------------------
// Reducer
// ------------------------------------
const initialState = {}
function reducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type]
  return handler ? handler(state, action) : state
}

export default function(history) {
  return {
    id: 'utilityMain',
    reducerMap: {
      utilityMainState: reducer
    },
    // middlewares when this module needed
    middlewares: [apiMiddleware, routerMiddleware(history)]
    // Actions to fire when this module is added/removed
    // initialActions: [],
    // finalActions: []
  }
}
